import { render, staticRenderFns } from "./ConsolidadoTerrestre.vue?vue&type=template&id=6b0c93a0&scoped=true"
import script from "./ConsolidadoTerrestre.vue?vue&type=script&lang=js"
export * from "./ConsolidadoTerrestre.vue?vue&type=script&lang=js"
import style0 from "./ConsolidadoTerrestre.vue?vue&type=style&index=0&id=6b0c93a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0c93a0",
  null
  
)

export default component.exports